import React, { useState } from 'react'
import { BiHistory } from 'react-icons/bi'
import { Popover, PopoverContent, PopoverTrigger } from '@/features/shadcn/ui/popover'
import { formatRunAbsoluteTime, formatRunRelativeTime } from '../utils/scheduledTaskDisplay'
import { RunStatusBadge, RunTriggerBadge, runTimestamp } from './runHistoryMeta'

type Props = {
  runs: any[]
  selectedRunId: string | null
  onSelectRun: (runId: string) => void
}

export default function RunHistoryOverflow({ runs, selectedRunId, onSelectRun }: Props) {
  const [open, setOpen] = useState(false)
  const list = Array.isArray(runs) ? runs : []

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          title="Run history"
          aria-label="Run history"
          className="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-text-slate-600 hover:tw-bg-slate-50"
        >
          <BiHistory className="tw-h-4 tw-w-4" aria-hidden />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="tw-w-80 tw-max-h-80 tw-overflow-y-auto tw-p-1">
        <div className="tw-px-2 tw-py-1.5 tw-text-[11px] tw-font-medium tw-text-slate-500">
          Run history
        </div>
        {list.length === 0 && (
          <div className="tw-px-2 tw-py-3 tw-text-sm tw-text-slate-500">No runs yet</div>
        )}
        {list.map((run: any) => {
          const ts = runTimestamp(run)
          const selected = run.id === selectedRunId
          return (
            <button
              key={run.id}
              type="button"
              onClick={() => {
                onSelectRun(run.id)
                setOpen(false)
              }}
              className={`tw-flex tw-w-full tw-items-start tw-gap-2 tw-rounded-md tw-px-2 tw-py-2 tw-text-left ${
                selected ? 'tw-bg-sky-50' : 'hover:tw-bg-slate-50'
              }`}
            >
              <div className="tw-min-w-0 tw-flex-1">
                <div className="tw-text-[13px] tw-font-medium tw-text-slate-800">
                  {formatRunRelativeTime(ts) || 'Unknown time'}
                </div>
                <div className="tw-mt-0.5 tw-text-[11px] tw-text-slate-500" title={formatRunAbsoluteTime(ts)}>
                  {formatRunAbsoluteTime(ts)}
                </div>
                <div className="tw-mt-1.5 tw-flex tw-flex-wrap tw-gap-1">
                  <RunStatusBadge status={run.status} />
                  <RunTriggerBadge run={run} />
                </div>
              </div>
            </button>
          )
        })}
      </PopoverContent>
    </Popover>
  )
}
